import React, { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { env } from "../config";
import * as Actions from "../redux/actions";
import Loader from "../components/Loader";
import { useLocation } from "react-router";
import Footer from "../components/Footer";
import CloudStackDevelopmentPageIntro from "../components/CloudstackPageIntro";
import CloudStackDevelopmentPageDescription from "../components/CloudstackDescription";
import CloudStackCards from "../components/CloustackCards";
import CloudStackDarkCards from "../components/CloudstackDarkCards";
import CloudStackStructuredCards from "../components/CloudstackStructuredCards";
import CloudStackFaq from "../components/CloudStackFaq";
import CloudStackContact from "../components/CloudstackContact";
import ProductdevelopmentIntro from "../components/ProductdevelopmentIntro";
const CompanyPageIntro = React.lazy(
    () => import("../components/CompanyPageIntro")
);

const ContactUsSection = React.lazy(
    () => import("../components/ContactUsSection")
);

function CloudStackPage() {
    const CloustackData: any = useSelector(
        (state: any) => state?.Page?.CloudStackPageContent
    );

    const dispatch = useDispatch();

    let url = "/api/cloud-stack-page-content?populate=deep";
    let action = Actions.CloudStackpageAction;

    useEffect(() => {
        if (Object.keys(CloustackData).length === 0) {
            setTimeout(() => {
                (async () => {
                    await axios
                        .get(`${env}${url}`)
                        .then(function (response) {
                            dispatch(action(response?.data?.data?.attributes));
                        })
                        .catch((error: any) => {
                            console.log("error", error);
                        });
                })();
            }, 0);
        }
        window.scrollTo({
            top: 0,
            left: 1,
            behavior: "smooth",
        });
    }, [dispatch]);

    const isLoading = Object.keys(CloustackData).length === 0;


    return isLoading ? (
        <Loader />
    ) : (
        <>
            <Suspense fallback={<Loader />}>
                <CloudStackDevelopmentPageIntro ProductDevelopmentPageIntro={CloustackData?.intro} />
                <CloudStackDevelopmentPageDescription description={CloustackData?.description} />
                <CloudStackCards title={CloustackData?.platform?.Title} Features={CloustackData?.platform?.Cards} description={CloustackData?.platform?.Description} />
                <CloudStackDarkCards title={CloustackData?.cost?.Title} Features={CloustackData?.cost?.Cards} description={CloustackData?.cost?.Description} />
                <CloudStackStructuredCards description={CloustackData?.structured} />
                <ProductdevelopmentIntro ProductDevelopmentPageIntro={CloustackData?.locked} imagePosition="w-auto h-full" />
                <CloudStackCards title={CloustackData?.built?.Title} Features={CloustackData?.built?.Cards} description={CloustackData?.built?.Description} />
                <CloudStackFaq title={CloustackData?.faq?.Title} Features={CloustackData?.faq?.Cards} description={CloustackData?.faq?.Description} />
                <CloudStackContact Contact={CloustackData?.contact} />
                <Footer />
            </Suspense>
        </>
    );
}

export default CloudStackPage;
